// @ts-nocheck

import { useMemo } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { KLBadgeAssetByBadgeId } from '../../constants/assets';
import { KL_BADGE_HALO_DURATION } from '../../constants/ui';
import SharedStyle from '../../styled-component/shared';
import { type KLCollectibleId, KLCollectibleStatus, KLCollectibleStatuses } from '../../types/collectible';

const haloAnim = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  cursor: pointer;

  ${SharedStyle.ImageAsButtonsBehaviour}

  ${({ $isPending, $animationDelay }) => {
    if ($isPending && typeof $animationDelay === 'number') {
      return css`
        &:before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: transparent;
          box-shadow: inset 0px 0px 20px 6px #e5ab29aa;
          opacity: 0;

          animation: ${haloAnim} ${KL_BADGE_HALO_DURATION}ms ease-in-out ${$animationDelay}ms infinite;
        }

        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: transparent;
          box-shadow: 0px 0px 20px 6px #e5ab29aa;
          opacity: 0;

          animation: ${haloAnim} ${KL_BADGE_HALO_DURATION}ms ease-in-out ${$animationDelay}ms infinite;
        }
      `;
    }
  }}
`;

const StyledBadge = styled.img`
  width: 100%;
`;

type KLBadgeProps = {
  className?: string;
  badgeId: KLCollectibleId;
  status: KLCollectibleStatus;
  animationDelay: number;
  onClick: () => void;
};

const KLBadge = ({ badgeId, status, onClick = () => {}, animationDelay, className = '' }: KLBadgeProps) => {
  const assetPath = useMemo(() => {
    if (status === KLCollectibleStatuses.WON) {
      return KLBadgeAssetByBadgeId[badgeId]?.won;
    }

    if (status === KLCollectibleStatuses.PENDING) {
      return KLBadgeAssetByBadgeId[badgeId]?.pending;
    }

    return KLBadgeAssetByBadgeId[badgeId]?.default;
  }, [badgeId, status]);
  const isPending = useMemo(() => status === KLCollectibleStatuses.PENDING, [status]);

  return assetPath ? (
    <Wrapper className={className} onClick={onClick} $isPending={isPending} $animationDelay={animationDelay}>
      <StyledBadge src={assetPath} alt={`badge-${badgeId}`} />
    </Wrapper>
  ) : null;
};

export default KLBadge;
